import { TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import { Color, ColorResult, TwitterPicker } from 'react-color';
import React, { useCallback } from 'react';

export interface TagColorPickerProps {
	color: Color;
	onChange: (color: string) => void;
}

export const TagColorPicker: React.FC<TagColorPickerProps> = ({ color, onChange }) => {
	const handleChange = useCallback(
		(result: ColorResult) => {
			onChange(result.hex);
		},
		[ onChange ]
	);

	return <TwitterPicker
		color={ color }
		colors={ TAG_COLORS }
		onChange={ handleChange }
		triangle='hide' />;
};
